var table_viewer_default = {
  "viewMode": "q6nEZ",
  "editMode": "BVGMI",
  "container": "fE8Ev",
  "cell": "DIzjB"
};
export {
  table_viewer_default as default
};
//# sourceMappingURL=table-viewer-scss.js.map
